// Smooth wavy SVG divider used to transition Hero → Services
export default function WaveDivider({
  fromColor = "transparent",
  toColor = "#ffffff",
  className = "",
  flip = false,
}) {
  return (
    <div
      className={`pointer-events-none absolute inset-x-0 ${
        flip ? "top-0 -scale-y-100" : "bottom-0"
      } leading-[0] ${className}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 220"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="block h-[120px] w-full sm:h-[180px]"
      >
        <defs>
          <linearGradient id="wd-wave-1" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={toColor} stopOpacity="0.35" />
            <stop offset="100%" stopColor={toColor} stopOpacity="0.85" />
          </linearGradient>
          <linearGradient id="wd-wave-2" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={toColor} stopOpacity="0.7" />
            <stop offset="100%" stopColor={toColor} stopOpacity="1" />
          </linearGradient>
        </defs>
        {/* Back wave */}
        <path
          fill="url(#wd-wave-1)"
          d="M0,128 C180,180 320,80 540,110 C760,140 900,200 1120,170 C1280,148 1360,120 1440,140 L1440,220 L0,220 Z"
        />
        {/* Front wave */}
        <path
          fill="url(#wd-wave-2)"
          d="M0,170 C180,200 320,150 540,160 C760,170 900,210 1120,195 C1280,184 1360,170 1440,180 L1440,220 L0,220 Z"
        />
      </svg>
    </div>
  );
}
